import React, { useEffect } from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import App from "./App";
import "./index.css";

// Wrapper component for /tab route that forces viewport recomputation to counter Android WebView setInitialScale(200)
function TabWrapper() {
  useEffect(() => {
    const forceMetaRecompute = () => {
      const meta = document.querySelector("meta[name=viewport]");
      if (meta) {
        meta.setAttribute("content", "width=device-width, initial-scale=1.0, maximum-scale=10.0, user-scalable=yes");
      } else {
        const m = document.createElement("meta");
        m.name = "viewport";
        m.content = "width=device-width, initial-scale=1.0, maximum-scale=10.0, user-scalable=yes";
        document.head.appendChild(m);
      }
      // Force a dummy change to window size / layout to trigger recomputation
      document.body.style.width = "99vw";
      setTimeout(() => {
        document.body.style.width = "100vw";
        window.dispatchEvent(new Event("resize"));
      }, 20);
    };

    forceMetaRecompute();

    // Cleanup function to restore original state
    return () => {
      const meta = document.querySelector("meta[name=viewport]");
      if (meta) {
        meta.setAttribute("content", "width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no");
      }
      document.body.style.width = "";
    };
  }, []);

  return <App />;
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <BrowserRouter>
    <Routes>
      <Route path="/" element={<App />} />
      <Route path="/tab" element={<TabWrapper />} />
    </Routes>
  </BrowserRouter>
);
